import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { Parallax } from "react-parallax";
import { scrollDuration } from "../../../config/commonConfig";
import FullScreenNav from "./HeaderFullScreenNav";
import TextTransition, { presets } from "react-text-transition";

const TEXTS = ["Moment", "Picture", "Emotion"];

export const IntroHeader = ({
  // Background type and source
  backgroundType = "image", // "video" or "image"
  backgroundSrc,
  
  // Styling
  maskClass = "opacity-8 bg-dark",
  
  // Content customization (optional props with defaults)
  title = "creator of",
  buttonText = "Meine Bilder",
  buttonLink = "portfolio",
  secondaryButtonText = "Deine Momente",
  secondaryButtonLink = "contact",
  scrollToSection = "about"
}) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(
      () => setIndex(index => index + 1),
      3000 // every 3 seconds
    );
    return () => clearTimeout(intervalId);
  }, []);

  // Render the appropriate background
  const renderBackground = () => {
    if (backgroundType === "video") {
      return (
        <div className="player hero-bg">
          <video
            src={backgroundSrc}
            autoPlay
            muted
            loop
            style={{
              width: "100%",
              height: "100vh",
              minHeight: "100%",
              objectFit: "cover",
            }}
          ></video>
        </div>
      );
    } else {
      return (
        <Parallax
          bgImage={backgroundSrc}
          bgImageAlt="Intro"
          strength={200}
        >
          <div className="hero-content d-flex fullscreen py-5">
            {renderContent()}
          </div>
        </Parallax>
      );
    }
  };

  // Extract content to reuse in both video and image versions
  const renderContent = () => (
    <>
      <div className="container my-auto py-4">
        <div className="row">
          <div className="col-lg-5 text-center text-lg-start align-self-center order-0 order-lg-0">
            <div className="d-inline-block p-5 wow zoomIn">
              <img
                className="img-fluid d-block"
                src="images/logo_weiss_transparent.png"
                title="Arnet Photography"
                alt="Logo Arnet Photography"
              />
            </div>
          </div>

          <div className="col-lg-7 text-center text-lg-start align-self-center order-1 order-lg-1">
            <h1 className="text-8 fw-300 mb-0 text-uppercase">
              {title}
            </h1>
            <h2 className="text-20 fw-600 text-uppercase mb-0 ms-n1">
              <TextTransition springConfig={presets.gentle} inline>
                {TEXTS[index % TEXTS.length]}
              </TextTransition>
              S{""}
            </h2>
            <p className="text-5"> </p>
            <Link
              className="btn btn-dark rounded-0 smooth-scroll mt-3"
              smooth="easeInOutQuint"
              duration={scrollDuration}
              style={{ cursor: "pointer" }}
              to={buttonLink}
            >
              {buttonText}
            </Link>
            <Link
              className="btn btn-link text-dark smooth-scroll mt-3"
              smooth="easeInOutQuint"
              duration={scrollDuration}
              style={{ cursor: "pointer" }}
              to={secondaryButtonLink}
            >
              {secondaryButtonText}
              <span className="text-4 ms-2">
                <i className="far fa-arrow-alt-circle-down" />
              </span>
            </Link>
          </div>
        </div>
      </div>

      <Link
        className="scroll-down-arrow text-light smooth-scroll"
        smooth="easeInOutQuint"
        duration={scrollDuration}
        style={{ cursor: "pointer" }}
        to={scrollToSection}
      >
        <span className="animated">
          <i className="fas fa-arrow-down" />
        </span>
      </Link>
    </>
  );

  return (
    <>
    <FullScreenNav />
    <section id="home">
      <div className="hero-wrap">
        <div className={`hero-mask ${maskClass}`} />
        
        {backgroundType === "video" ? (
          <>
            {renderBackground()}
            <div className="hero-content py-5 d-flex fullscreen">
              {renderContent()}
            </div>
          </>
        ) : (
          renderBackground()
        )}
      </div>
    </section>
    </>
  );
};
